import {
    ENTRY_FEE,
    FIRST_PLACE_PRICE,
} from "../constants";

export const prizeCalculatorSeason3 = (playersCount: number) => {
    const prizeList = [];

    if (playersCount < 10) {
        prizeList[0] = FIRST_PLACE_PRICE;
        return prizeList;
    }

    let prizeSum = 0;
    const RATIO = 1.3;

    const totalPrize = 50000 + ENTRY_FEE * playersCount;
    const remainder =
        totalPrize - (100 + 150 + 200 + 250 + 300 + 350) * playersCount * 0.05;

    for (let i = 0; i < playersCount; i++) {
        const RANK = i + 1;
        prizeList[i] = Math.round(
            ((RATIO - 1) * remainder) / Math.pow(RATIO, RANK)
        );
        const percentile = RANK / playersCount;
        if (percentile <= 0.05) prizeList[i] += 350;
        if (percentile > 0.05 && percentile <= 0.1) prizeList[i] += 300;
        if (percentile > 0.1 && percentile <= 0.15) prizeList[i] += 250;
        if (percentile > 0.15 && percentile <= 0.2) prizeList[i] += 200;
        if (percentile > 0.2 && percentile <= 0.25) prizeList[i] += 150;
        if (percentile > 0.25 && percentile <= 0.3) prizeList[i] += 100;
        if (percentile > 0.3) prizeList[i] = 0;
        if (i > 0 && prizeList[i] > 0) {
            prizeSum += prizeList[i];
        }
    }

    prizeList[0] = totalPrize - prizeSum;
    prizeList?.unshift(FIRST_PLACE_PRICE);
    return prizeList;
};
